/*
  This is a template for creating a Component class.

  Instructions: copy and paste this file into your newly created react component index.js. Then
  change the appropriate names and add your html render
    The base class for all components should be BaseClass (as indicated in this file)
    The base class insures that all call back handlers with "handle" in the name are bound
    to "this". This insures that "this" is defined as "this" for the containing class
*/

import React from 'react';
import BaseComponent from '../../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import Circle from '../../graphics/Circle';
import './CloseButton.scss';

// Change CloseButton to the appropriate name
class CloseButton extends BaseComponent {

  componentDidMount() {
  }

  // All event handlers or callback functions that need to have "this" available
  // Need to have "handle" (case in-sensitive) in the name. Matching names would be:
  //    handleResponse
  //    dateTimeHandler
  //    HandlesMessiah (not Handels however)
  myHandleClick(e){
    e.stopPropagation();
    const { handleClick } = this.props;
    if (handleClick){
      handleClick(e);
    }
  }

  render() {
    const{ left, top, width, height, fillColor, borderColor, hasShadow, className } = this.props;
    const style = { left: left + 'px', top: top + 'px', width: width + 'px', height: height + 'px' };
    const classNames = 'close-button ' + (hasShadow ? 'has-shadow' : '') + (className ? className : '');
    return (
      <div className={classNames} style={style} onClick={this.myHandleClick}>
        <Circle fillColor={fillColor} borderColor={borderColor} left={0} top={0}
          width={width} height={height} position={'absolute'}/>
        <p style={{ top: width === 15 ? '0px' : '' }}>X</p>
      </div>
    );
  }
}

export default (CloseButton);



// WEBPACK FOOTER //
// ./src/components/Buttons/CloseButton/index.js